// src/components/Projects/ProjectCards.jsx
import React from "react";
import ProjectCard from "./ProjectCard";
import projects from "./projectsData";

function ProjectCards({ filterCategory, title, subtitle, layout = "sidebar" }) {
  const visibleProjects = filterCategory
    ? projects.filter((project) => project.category === filterCategory)
    : projects;

  if (!visibleProjects.length) return null;

  //  - "home": 3 u redu na desktopu, 2 na tabletu, 1 na mobu
  //  - "sidebar": 2 u redu na desktopu (u content 8/12 zbog sidebara)
  const columnClass =
    layout === "home" ? "col-12 col-sm-6 col-lg-4" : "col-12 col-md-6";

  return (
    <section className="mt-40">
      {title && (
        <div className="container">
          <div className="row">
            <div className="col-lg-12 p-relative">
              <div
                className="section-title center-align mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                {subtitle && (
                  <h5>
                    <i className="fas fa-globe-europe" /> {subtitle}
                  </h5>
                )}
                <h2>{title}</h2>
                <div className="section-divider" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row project-cards-row">
          {visibleProjects.map((project) => (
            <div key={project.id} className={`${columnClass} mb-4`}>
              {/* proslijediti layout */}
              <ProjectCard project={project} layout={layout} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProjectCards;
